import React from 'react'
import NewLoanApplicationButton from '@/pages/protected/pipeline/components/new-loan-application-button'

export default function TitleActions() {
	return <NewLoanApplicationButton />
}
